import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { activitiesApi } from '../api';
import type { Activity } from '../api/types';

// Shared query key for object activities
export const objectActivitiesQueryKey = (objectId: string, objectType: string) => ['activities', 'object', objectType, objectId] as const;

/**
 * Shared hook to fetch all activities for an object.
 * This prevents duplicate API calls by providing a single source of truth.
 * Other hooks can use this data and filter it as needed.
 */
export function useObjectActivities(objectId, objectType, options) {
  const $ = _c(10);
  let t0;
  if ($[0] !== objectId || $[1] !== objectType) {
    t0 = objectActivitiesQueryKey(objectId, objectType);
    $[0] = objectId;
    $[1] = objectType;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== objectId || $[4] !== objectType) {
    t1 = async () => await activitiesApi.getObjectFeed(objectId, objectType);
    $[3] = objectId;
    $[4] = objectType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = options?.enabled !== false && !!objectId && !!objectType;
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 10000
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useQuery(t3);
}